import { Box, VStack } from "@chakra-ui/react";

import Type from "../../../utilies/Types";

import UsersAndTeamManagement from "./user";
import TaskManagement from "./task";

import AddonsMenu from "./addons";
import RightMenuReviewerPanel from "./reviewer";
import { useAppStore } from "../../../context/store";

import ActiveInfoBox from "./ActiveInfoBox";
function SideBarLeft({ droppedFiles }) {
  const userType = useAppStore((s) => s.userType);

  return (
    <Box position="absolute" top="55px" left="10px" zIndex={1001} pointerEvents="none">
      <VStack gap={1} align="flex-start" display="inline-flex" w="fit-content" sx={{ "& > *": { width: "fit-content" } }}>
        <Box pointerEvents="auto" mt={"15px"}>
          <ActiveInfoBox />
        </Box>

        {userType.includes(Type.ROLE.ADMIN) || userType.includes(Type.ROLE.SUPER_ADMIN) ? (
          <Box pointerEvents="auto">
            <UsersAndTeamManagement />
          </Box>
        ) : null}

        <Box pointerEvents="auto">
          <TaskManagement />
        </Box>

        <Box pointerEvents="auto">
          <AddonsMenu droppedFiles={droppedFiles} />
        </Box>

        <Box pointerEvents="auto">
          <RightMenuReviewerPanel />
        </Box>
      </VStack>
    </Box>
  );
}

export default SideBarLeft;
